import { format, isThisYear, isToday, isValid, isYesterday, parseISO } from "date-fns";

const SNIPPET_MAX = 120;

export function formatInboxDate(value) {
  if (!value) return "—";
  const d = parseISO(String(value));
  if (!isValid(d)) return String(value);
  if (isToday(d)) return format(d, "h:mm a");
  if (isYesterday(d)) return "Yesterday";
  if (isThisYear(d)) return format(d, "MMM d");
  return format(d, "MM/dd/yy");
}

export function formatDetailDate(value) {
  if (!value) return "—";
  const d = parseISO(String(value));
  return isValid(d) ? format(d, "MMM d, yyyy 'at' h:mm a") : String(value);
}

export function notificationSnippet(message, max = SNIPPET_MAX) {
  const text = String(message ?? "")
    .replace(/\s+/g, " ")
    .trim();
  if (!text) return "";
  if (text.length <= max) return text;
  return `${text.slice(0, max).trim()}…`;
}

export { notificationSubjectTone } from "./notificationMessageParser";
